import { render, staticRenderFns } from "./PriceSummaryMenu.vue?vue&type=template&id=0bee945a&"
import script from "./PriceSummaryMenu.vue?vue&type=script&lang=js&"
export * from "./PriceSummaryMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports